import React from 'react';
import {
    Router as Router,
    Redirect,
    Route, Switch
} from 'react-router-dom';
import appRouter from './../core/router';
import mapScreen from './../screens/map';
import history from './history';

export default class extends React.Component {

    constructor(props) {
        super(props);

        let routes = [];

        Object.keys(this.props.screens).map((screenCode) => {
            if (!this.props.screens[screenCode].path) {
                this.props.screens[screenCode].path = ['/' + this.props.screens[screenCode].code];
            } else if (this.props.screens[screenCode].path && !Array.isArray(this.props.screens[screenCode].path)) {
                this.props.screens[screenCode].path = [this.props.screens[screenCode].path];
            }
            this.props.screens[screenCode].path.map((path) => {
                routes.push({
                    path: path,
                    screen: this.props.screens[screenCode].content,
                    appBar: this.props.screens[screenCode].appBar,
                    sidebar: this.props.screens[screenCode].sidebar,
                    exact: path.indexOf(':') > -1 ? false : true
                })
            });
        });

        this.state = {
            routes: routes
        }
        console.log('ROUTES: ', routes);
    }

    render() {
        return (
            <Router history={history}>
                <div>

                        <Route
                            key='index'
                            path='/'
                            exact={true}
                            component={() => <Redirect to={appRouter.getRouteTo(mapScreen)}/>}
                        />
                        {/* really necessry to have 3 route sections here?? */}
                        {this.state.routes.map((route, index) => (
                            <React.Fragment key={'route' + index}>
                                <Route
                                    key={'appBar' + index}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.appBar}
                                />
                                <Route
                                    key={'sidebar' + index}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.sidebar}
                                />
                                <Route
                                    key={'screen' + index}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.screen}
                                />
                            </React.Fragment>
                        ))}

                </div>
            </Router>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/router.jsx